import React from 'react'
import PropTypes from 'prop-types'
import TextInput from '../TextInput'
import DateTimeInput from '../DateTimeInput'

export default function SingleClosureInput(props) {
  return (
    <React.Fragment>
      <TextInput
        label="Reason for closure"
        isRequired={true}
        helperText={'50 character limit'}
        maxLength={50}
        onChange={newReason => props.onChange({...props.value, label: newReason})}
        value={props.value.label}
      />
      <DateTimeInput
        label={'Start date and start time'}
        onChange={startDate => props.onChange({...props.value, startAt: startDate})}
        min={new Date()}
        value={props.value.startAt}
      />
      <DateTimeInput
        label={'End date and end time'}
        onChange={endDate => props.onChange({...props.value, endAt: endDate})}
        value={props.value.endAt}
        disabled={!props.value.startAt}
        min={props.value.startAt}
      />
    </React.Fragment>
  )
}

SingleClosureInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired,
}
